module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/TbciMq/media/FC-9781645759706.jpg?1684514751617",
      "alt": "This image is the cover for the book Speakers"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Speakers\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "8.0pt",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "color": "black",
      "background": "white"
    }
  }, [_vm._v("While the Alsoo refugees on Earth learn about and explore their new home world, those Also")]), _c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "color": "black",
      "background": "white"
    }
  }, [_vm._v("o")]), _c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "color": "black",
      "background": "white"
    }
  }, [_vm._v(" that remained behind explore a home")]), _c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "color": "black",
      "background": "white"
    }
  }), _c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "color": "black",
      "background": "white"
    }
  }, [_vm._v("world changed beyond recognition. ")])]), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "8.0pt",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "color": "black",
      "background": "white"
    }
  }, [_vm._v("Both ")]), _c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "color": "black",
      "background": "white"
    }
  }, [_vm._v("groups will find ")]), _c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "color": "black",
      "background": "white"
    }
  }, [_vm._v("new dangers and new obstacles to overcome")]), _c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "color": "black",
      "background": "white"
    }
  }, [_vm._v(" as they seek to rebuild their lives…")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Henry A. Burns\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', {
    staticClass: "BodyA",
    staticStyle: {
      "margin": "0cm",
      "margin-bottom": ".0001pt",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif",
      "color": "black",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("Henry A. Burns was born in Brooklyn, New York. He wrote his first story, "), _c('em', [_vm._v("The Sunshine Car,")]), _vm._v(" when he was five. He studied drama and acting in junior high and high school to get over his innate shyness. After college, writing was put on hold to pursue a career. Now retired, he lives in San Francisco with his wife, his cats, and three bearded dragons. "), _c('em', [_vm._v("Speakers")]), _vm._v(" is his third published book.")])]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0